import util from '../util';
import Widget from './Widget';
import './goalWidget.scss';

export default class GoalWidget extends Widget {
	applySettings(settings) {
		super.applySettings(settings);
		this.container.classList.toggle('striped', !!this.settings.stripes);
		this._goal = parseInt(this.settings.goal || 0) || 0;
		this._render();
	}

	_build() {
		super._build();
		this.container.classList.add('goal-widget');
		this.container.innerHTML = `
			<div class="progressBar">
				<div class="progressAmount"></div>
				<div class="title"></div>
				<div class="progressText"></div>
				<div class="goal"></div>
			</div>
		`;
	}

	_generateCSS() {
		const id = this.container.id, s = this.settings;
		const valign = { top: 'flex-start', middle: 'center', bottom: 'flex-end' }[s.verticalAlign];

		return `
			.goal-widget#${id} {
				${valign ? `justify-content: ${valign};` : ''}
				${s.textColor ? `color: ${s.textColor};` : ''}
				${s.fontFamily ? `font-family: '${s.fontFamily}';` : ''}
				${s.fontSize > 0 ? `font-size: ${s.fontSize}px;` : ''}
				${s.letterSpacing > 0 ? `letter-spacing: ${s.letterSpacing}px;` : ''}
				${s.boldText ? 'font-weight: bold;' : ''}
				${s.italicText ? 'font-style: italic;' : ''}
				${(s.underlineText || s.strikethroughText) ? `text-decoration: ${s.underlineText ? 'underline' : ''} ${s.strikethroughText ? 'line-through' : ''};` : ''}
				${s.uppercaseText ? 'text-transform: uppercase;' : ''}
			}
			.goal-widget#${id} > .progressBar {
				${s.backColor ? `background-color: ${s.backColor};` : ''}
				${s.borderRadius > 0 ? `border-radius: ${s.borderRadius}px;` : ''}
				${s.borderWidth > 0 && s.borderColor ? `border: ${s.borderWidth}px solid ${s.borderColor};` : ''}
				${s.padding > 0 ? `padding: ${s.padding}px;` : ''}
			}
			.goal-widget#${id} > .progressBar > .progressAmount {
				${s.barColor ? `background-color: ${s.barColor};` : ''}
			}
			${s.blurRadius > 0 || s.spreadRadius > 0 ? `
				.goal-widget#${id} > .progressBar > .progressText,
				.goal-widget#${id} > .progressBar > .title,
				.goal-widget#${id} > .progressBar > .goal {
					filter ${util.generateSpreadShadowFilter(s.spreadRadius, s.blurRadius, s.shadowColor)};
				}
			` : ''}
			${s.extraCSS || ''}
		`;
	}

	setGoal(goal) {
		this._goal = goal;
		this._render();
	}

	setTitle(subtitle) {
		this.subtitle = subtitle;
		const titleEl = this.container.querySelector('.title');
		if(titleEl) titleEl.innerText = subtitle || '';
	}

	_render() {
		if(!this.settings) return;
		const progressAmountEl = this.container.querySelector('.progressAmount');
		if(!progressAmountEl) return;

		const total = parseInt(this.settings.count || 0) || 0;
		const goal  = this._goal || 0;
		const pct   = goal ? Math.round(Math.min(total, goal) / goal * 100) : 0;

		progressAmountEl.style.width = `${pct}%`;

		const titleEl        = this.container.querySelector('.title');
		const progressTextEl = this.container.querySelector('.progressText');
		const goalEl         = this.container.querySelector('.goal');

		if(titleEl) titleEl.innerText = this.settings.title || '';
		if(progressTextEl) progressTextEl.innerText = this.settings.hidePercentage ? String(total) : `${total} (${pct}%)`;
		if(goalEl) goalEl.innerText = goal ? String(goal) : '';
	}
}
